export default "__VITE_ASSET__CTY6tS4P__"